import { Nux } from "../../api/api-nux";

const NuxActions = {
  terms: {
    action: function () {
      location.href = "/updated-terms";
    },
  },
};

const getUserExperiences = function (query, accessToken, callback) {
  Nux.read(query, accessToken, function (res) {
    if (res.error || 400 < res.statusCode) {
      return;
    }
    callback(res, NuxActions);
  });
};

export { getUserExperiences };
